import Axios from "../../../../api/axios/Axios";

export const searchGroupContent = (
  groupTag,
  { q = "", type = "all", limit = 20, offset = 0, signal } = {},
) => {
  const tag = String(groupTag ?? "").trim();

  if (!tag) {
    throw new Error("Group tag is required.");
  }

  return Axios.get(`/api/groups/${encodeURIComponent(tag)}/search`, {
    params: {
      q,
      type,
      limit,
      offset,
    },
    signal,
  });
};
